import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Button, RadioGroup, Grid } from "@mui/material";
import {
  addErrorMessage,
  addNewMessage,
  addSuccessMessage,
  setIsLoading,
  setReloadBasicInformationData,
  setReloadDemandsInformationData,
  setReloadDocumentsInformationData,
  setReloadEducationInformationData,
  setReloadFamilyInformationData,
  setReloadFinancialInformationData,
  setReloadPersonalInformationData,
} from "../../slice";
import { PROFILES_API, MATCH_API } from "../../api";
import { useCurrentState } from "../../hooks";
import BaseRadio from "../all-inputs/BaseRadio";
import ConfirmModal from "../ConfirmModal";

const DashboardMessageCard = () => {
  const updateUserStatus = useCurrentState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { messages } = useSelector((state) => state.DashboardMessages);
  const { data, userInfo } = useSelector((state) => state.UserCurrentState);
  const [selectCandidateType, setSelectCandidateType] = useState(0);
  const [message, setMessage] = useState(messages[0]);
  const [firstContactCode, setFirstContactCode] = useState();
  const [firstContactTypes, setFirstContactTypes] = useState([]);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const currentLocation = location.pathname.split("/")[1];

  const { mutate: approveEditedProfileFromInterviewer } = useMutation(
    () => PROFILES_API.ApproveEditedProfileFromInterviewer(),
    {
      onSuccess: () => {
        //todo: inja byd handle beshe
        updateUserStatus();
      },
      onError: () => {
        //todo:inja byd handle beshe
      },
    }
  );

  const { mutate: rejectEditedProfileFromInterviewer } = useMutation(
    () => PROFILES_API.RejectEditedProfileFromInterviewer(),
    {
      onSuccess: () => {
        //todo: inja byd handle beshe
        updateUserStatus();
        dispatch(setReloadBasicInformationData(true));
        dispatch(setReloadFamilyInformationData(true));
        dispatch(setReloadEducationInformationData(true));
        dispatch(setReloadFinancialInformationData(true));
        dispatch(setReloadPersonalInformationData(true));
        dispatch(setReloadDemandsInformationData(true));
        dispatch(setReloadDocumentsInformationData(true));
      },
      onError: () => {
        //todo:inja byd handle beshe
      },
    }
  );

  const { mutate: acceptFirstContactTypeChosen } = useMutation(
    () => MATCH_API.AcceptFirstContactTypeChosen(),
    {
      onSuccess: () => {
        //todo: inja byd handle beshe
        updateUserStatus();
      },
      onError: () => {
        //todo:inja byd handle beshe
      },
    }
  );

  const { mutate: approveMatchByMan } = useMutation(
    () => MATCH_API.ApproveMatchByMan(message.metaData),
    {
      onSuccess: ({ data: { message } }) => {
        //todo: inja byd handle beshe
        dispatch(
          addNewMessage({
            text: message,
            id: "success-on-approve-match-by-man",
            type: "success",
          })
        );
        updateUserStatus();
        navigate("/");
      },
      onError: ({
        response: {
          data: { message },
        },
      }) => {
        //todo:inja byd handle beshe
        dispatch(
          addNewMessage({
            id: "error-on-approve-match-by-man",
            text: message,
            type: "error",
          })
        );
      },
    }
  );

  const { mutate: approveMatchByhWoman } = useMutation(
    () => MATCH_API.ApproveMatchByhWoman(message.metaData),
    {
      onSuccess: ({ data: { message } }) => {
        //todo: inja byd handle beshe
        dispatch(
          addNewMessage({
            text: message,
            id: "success-on-approve-match-by-woman",
            type: "success",
          })
        );
        updateUserStatus();
        navigate("/");
      },
      onError: ({
        response: {
          data: { message },
        },
      }) => {
        //todo:inja byd handle beshe
        dispatch(
          addNewMessage({
            text: message,
            id: "error-on-approve-match-by-woman",
            type: "error",
          })
        );
      },
    }
  );

  const { mutate: rejectMatch } = useMutation(
    (body) => MATCH_API.RejectMatch(message.metaData, body),
    {
      onSettled: () => {
        dispatch(setIsLoading(false));
        setShowConfirmModal(false);
      },
      onSuccess: ({ data: { message } }) => {
        dispatch(
          addNewMessage({
            text: message,
            id: "success-on-reject-match",
            type: "success",
          })
        );
        updateUserStatus();
        navigate("/");
      },
      onError: ({
        response: {
          data: { message },
        },
      }) => {
        //todo:inja byd handle beshe
        dispatch(
          addNewMessage({
            id: "error-on-reject-match",
            text: message,
            type: "error",
          })
        );
      },
    }
  );

  const { mutate: rejectMatchAndSearchAgainAfterRejectAllCandidates } = useMutation(
    (isSearchByBranch) =>
      MATCH_API.RejectMatchAndSearchAgainAfterRejectAllCandidates(isSearchByBranch),
    {
      onSuccess: () => {
        //todo: inja byd handle beshe
        updateUserStatus();
      },
      onError: () => {
        //todo:inja byd handle beshe
      },
    }
  );

  const { mutate: ChooseSearchByType } = useMutation(
    (type) => PROFILES_API.ChooseSearchByType(type),
    {
      onError: () => {
        dispatch(
          addNewMessage({
            id: "error-on-search",
            text: "مشکلی برای ارسال درخواست شما به وجود آمده است.",
            type: "error",
          })
        );
      },
      onSuccess: (data, type) => {
        updateUserStatus();
        if (type)
          dispatch(
            addNewMessage({
              text: "درخواست شما با موفقیت ارسال شد.",
              id: "success-on-search",
              type: "success",
            })
          );
      },
    }
  );

  const { mutate: selectFirstContactType } = useMutation(
    () => MATCH_API.SelectFirstContactType(firstContactCode),
    {
      onSuccess: ({ data }) => {
        if (data.success) {
          updateUserStatus();
        }
      },
      onError: (error) => {
        console.log(error);
        dispatch(
          addNewMessage({
            id: "failed-on-get-first-contact-type",
            text: "مشکلی پیش  آمده مجدد تلاش کنید.",
            type: "error",
          })
        );
      },
      onSettled: () => setOpenConfirmModal(false),
    }
  );

  const { mutate: ContinuationRequestProfileDefined } = useMutation(
    () => PROFILES_API.ContinuationRequestProfileDefined(),
    {
      onSuccess: ({ data: { message } }) => {
        //todo: inja byd handle beshe
        updateUserStatus();
        dispatch(addSuccessMessage(message));
      },
      onError: ({ response }) => {
        //todo:inja byd handle beshe
        dispatch(addErrorMessage(response));
      },
    }
  );

  const { mutate: UnderstandDuringApprove } = useMutation(
    () => MATCH_API.IUnderstandDuringApproveMatchByMan(),
    {
      onSuccess: ({ data: { message } }) => {
        updateUserStatus();
        dispatch(addSuccessMessage(message));
      },
      onError: ({ response: { data } }) => {
        dispatch(addErrorMessage(data));
      },
    }
  );

  const handleSelectCandidateType = () => {
    // todo: address drst api ha bye porside shavad
    switch (selectCandidateType) {
      case 1:
        rejectMatchAndSearchAgainAfterRejectAllCandidates(false);
        break;
      case 2:
        rejectMatchAndSearchAgainAfterRejectAllCandidates(true);
        break;
      default:
        dispatch(
          addNewMessage({
            id: "no-select-on-candidate-type",
            type: "warn",
            text: "لطفا یک گزینه را انتخاب کنید.",
          })
        );
        break;
    }
  };

  const handleOpenFirstContactConfirmModal = () => {
    if (firstContactCode) {
      setOpenConfirmModal(true);
    } else {
      dispatch(
        addNewMessage({
          id: "failed-on-get-first-contact-type",
          text: "لطفا یکی از گزینه‌ها را انتخاب کنید.",
          type: "error",
        })
      );
    }
  };

  const parseBody = (body) => {
    const parts = body.split(/(\s+)/);
    return parts.map((part, i) => {
      if (/https?:\/\/[^\s]+/.test(part)) {
        return (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "underline" }}
          >
            {part}
          </a>
        );
      }

      if (/0\d{10}/.test(part)) {
        return (
          <a key={i} href={`tel:${part}`} style={{ color: "#1976d2", textDecoration: "underline" }}>
            {part}
          </a>
        );
      }

      return part;
    });
  };

  useQuery(["getFirstContactTypes"], () => MATCH_API.GetFirstContactTypes(), {
    onSuccess: ({ data }) => {
      if (data.success) {
        setFirstContactTypes(data.data);
      } else {
        dispatch(
          addNewMessage({
            id: "failed-on-get-first-contact-type",
            text: "مشکلی پیش  آمده مجدد تلاش کنید.",
            type: "error",
          })
        );
      }
    },
    onError: () => {
      dispatch(
        addNewMessage({
          id: "failed-on-get-first-contact-type",
          text: "مشکلی پیش  آمده مجدد تلاش کنید.",
          type: "error",
        })
      );
    },
    enabled:
      data.code !== undefined &&
      parseInt(data.code) === 47 &&
      parseInt(userInfo.genderTypeEnum) === 2,
  });

  useEffect(() => {
    //? handling code = 21
    if (currentLocation === "personal-info") {
      if (parseInt(data?.code) === 21) {
        setMessage(messages[1]);
      } else {
        setMessage(messages[0]);
      }
    } else {
      setMessage(messages[0]);
    }
    //? handling codes = [60 , 61 , 62 , 63]
    if (currentLocation === "candidate") {
      if (
        ([60, 61].includes(parseInt(data.code)) && parseInt(userInfo.genderTypeEnum) === 1) ||
        ([62, 63].includes(parseInt(data.code)) && parseInt(userInfo.genderTypeEnum) === 2)
      ) {
        setMessage(messages[1]);
      }
    }
  }, [currentLocation, messages, data, userInfo]);

  //? handling code = 1
  if (currentLocation === "wait" || currentLocation === "wait-for-candidate") {
    return;
  }

  //? handling select first contact type
  if (currentLocation === "first-contact") {
    return;
  }

  //? handling code = 18 & code = 24
  if (
    currentLocation === "personal-info" &&
    (parseInt(data.code) === 18 || parseInt(data.code) === 24)
  ) {
    return;
  }

  return (
    message && (
      <>
        <ConfirmModal
          message="آیا از انتخاب خود مطمئن هستید؟"
          open={openConfirmModal}
          onClose={() => setOpenConfirmModal(false)}
          onSubmit={selectFirstContactType}
        />
        <ConfirmModal
          message="آیا از انتخاب خود مطمئن هستید؟"
          open={showConfirmModal}
          confirm={true}
          withDiscription={true}
          onClose={() => setShowConfirmModal(false)}
          onSubmit={(a) => {
            dispatch(setIsLoading(true));
            rejectMatch(a.body);
          }}
        />
        <Typography variant="h2" color="#747474" my={2}>
          پیام‌های شما در حال حاضر:
        </Typography>
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="flex-start"
          sx={{
            backgroundColor: "#FAFAFA",
            boxSizing: "border-box",
            border: "3px solid #F9B5CD",
            borderRadius: "1rem",
            padding: "1rem",
            marginBottom: "1rem",
            boxShadow: "0px 6px 14px rgba(0, 0, 0, 0.09)",
          }}
        >
          <Box
            display="flex"
            width="100%"
            flexDirection="row-reverse"
            mb="1rem"
            justifyContent={parseInt(message.button) === 0 ? "flex-start" : "space-between"}
          >
            <Typography
              variant="h1"
              color={parseInt(data.code) === 47 && "#00BE93"}
              sx={{ direction: "rtl" }}
              fontWeight={700}
            >
              {message.title}
            </Typography>
            <Box display="flex">
              {parseInt(data.code) === 1 && (
                <Button onClick={navigate.bind(this, "/ticketing")} variant="accept">
                  پشتیبانی
                </Button>
              )}
              {(parseInt(data.code) === 18 || parseInt(data.code) === 24) && (
                <Button onClick={navigate.bind(this, "/personal-info/base-info")} variant="accept">
                  تکمیل پروفایل
                </Button>
              )}
              {parseInt(data.code) === 21 && currentLocation !== "personal-info" && (
                <Button onClick={navigate.bind(this, "/personal-info/base-info")} variant="accept">
                  نمایش اطلاعات
                </Button>
              )}
              {parseInt(data.code) === 21 && currentLocation === "personal-info" && (
                <Box>
                  <Button onClick={() => rejectEditedProfileFromInterviewer()} variant="cancel">
                    عدم تایید
                  </Button>
                  <Button onClick={() => approveEditedProfileFromInterviewer()} variant="accept">
                    تایید
                  </Button>
                </Box>
              )}
              {(([60, 61].includes(parseInt(data.code)) &&
                parseInt(userInfo.genderTypeEnum) === 1) ||
                ([62, 63].includes(parseInt(data.code)) &&
                  parseInt(userInfo.genderTypeEnum) === 2)) &&
                currentLocation !== "candidate" &&
                message?.metaData !== "returnUserState" && (
                  //todo: inja byd route handle beshe
                  <Button
                    onClick={navigate.bind(this, `/candidate/${message.metaData}`)}
                    variant="accept"
                  >
                    نمایش پروفایل همسان
                  </Button>
                )}

              {(([60, 61].includes(parseInt(data.code)) &&
                parseInt(userInfo.genderTypeEnum) === 1) ||
                ([62, 63].includes(parseInt(data.code)) &&
                  parseInt(userInfo.genderTypeEnum) === 2)) &&
                currentLocation === "candidate" &&
                message?.metaData !== "returnUserState" && (
                  //todo: inja byd route handle beshe
                  <Box>
                    <Button
                      onClick={() => {
                        setShowConfirmModal(true);
                      }}
                      variant="cancel"
                    >
                      موافق نیستم
                    </Button>
                    <Button
                      onClick={() => {
                        if (
                          [60, 61].includes(parseInt(data.code)) &&
                          parseInt(userInfo.genderTypeEnum) === 1
                        )
                          approveMatchByMan();
                        else if (
                          [62, 63].includes(parseInt(data.code)) &&
                          parseInt(userInfo.genderTypeEnum) === 2
                        )
                          approveMatchByhWoman();
                      }}
                      variant="accept"
                    >
                      موافق هستم
                    </Button>
                  </Box>
                )}

              {(([60, 61].includes(parseInt(data.code)) &&
                parseInt(userInfo.genderTypeEnum) === 1) ||
                ([62, 63].includes(parseInt(data.code)) &&
                  parseInt(userInfo.genderTypeEnum) === 2)) &&
                message?.metaData === "returnUserState" && (
                  <Button onClick={() => UnderstandDuringApprove()} variant="accept">
                    ادامه
                  </Button>
                )}
              {(parseInt(data.code) === 5 ||
                parseInt(data.code) === 68 ||
                parseInt(data.code) === 69) && (
                // {/* //todo: inja byd route handle beshe */}
                <Box>
                  <Button
                    variant="accept"
                    onClick={() => ChooseSearchByType(false)}
                    sx={{ mr: "2rem", mb: "1rem" }}
                  >
                    جستجو توسط خودم
                  </Button>
                  <Button
                    variant="accept"
                    onClick={() => ChooseSearchByType(true)}
                    sx={{ mr: "2rem", mb: "1rem" }}
                  >
                    جستجو توسط مركز
                  </Button>
                </Box>
              )}
              {parseInt(data.code) === 46 && (
                <Button onClick={acceptFirstContactTypeChosen} variant="accept">
                  متوجه شدم
                </Button>
              )}
              {parseInt(data.code) === 47 && parseInt(userInfo.genderTypeEnum) === 2 && (
                <Button onClick={handleOpenFirstContactConfirmModal} variant="accept">
                  ثبت
                </Button>
              )}
              {parseInt(data.code) === 71 && (
                <Button variant="accept" onClick={ContinuationRequestProfileDefined}>
                  ادامه
                </Button>
              )}
            </Box>
          </Box>
          <Box width="100%">
            <Typography
              component="pre"
              sx={{
                direction: "rtl",
                textAlign: "justify",
                whiteSpace: "pre-wrap",
                fontSize: "0.9rem",
                color: "#4C466F",
                fontWeight: 400,
                letterSpacing: "-0.01",
              }}
            >
              {parseBody(message.body)}
            </Typography>
          </Box>
          {parseInt(data.code) === 47 && parseInt(userInfo.genderTypeEnum) === 2 && (
            <Grid container justifyContent="flex-end">
              <RadioGroup
                onChange={(event) => setFirstContactCode(event.target.value)}
                sx={{ mb: "2rem", alignSelf: "flex-start" }}
              >
                {firstContactTypes.map((item) => (
                  <BaseRadio value={item.code} text={item.name} key={item.code} />
                ))}
              </RadioGroup>
            </Grid>
          )}
        </Box>
      </>
    )
  );
};

export default DashboardMessageCard;
